<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
              年客流走势
              <linechart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="usePerData"
              ></linechart>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import {getYOYTrendByTimes} from '@/request/api';
import linechart from "@/views/echart/LineEcharts"
export default {
  action: "PassengerFlowYear",
  controller: "UI",
  name: "PassengerFlowYear",
  components: {
    linechart
  },
  data(){
      return{
        usePerData: {},
        startYear:new Date().getFullYear() - 4
      }
  },
  mounted: function () {
    this.search();
  },
  methods:{
    search(){
      this.usePerData = {
        xData:[],
        yData:[{
          name:'',
          data:[]
        }]
      };
      let params = {
        "polityType": 3,
        "timeType": "year",
        "timeValue": 1,
        "district": "652302",
        "districtCode": "652302",
        "startTime": this.startYear +"-01-01",
        "endTime":new Date()
      }
      getYOYTrendByTimes(params).then(res=>{
        if(res.data){
          let dataList = res.data.dataList || {};
          var XData = [];
          var yDataObj = {
            name :'',
            data:[]
          };
          for (let key in dataList) {
            if(key == this.startYear){
                dataList[key].map((item) => {
                    const { dataTime, count } = item;
                    XData.push(dataTime);
                    yDataObj.data.push(count);
                });
            }
          }
          this.usePerData.yData.push(yDataObj);
          this.usePerData.xData = XData;
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 48%;
}
.echart_1{
  margin-bottom: 15px;
}
.echart_2{
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>